<template>
  <div class="goal-day-summary">
    <!-- <pre class="mini-pre">{{draggablesList}}</pre> -->
    <span v-if="draggablesList.length === 0">
      No session planned or recorded.
    </span>
    <component
      v-for="(item, idx) in draggablesList"
      v-bind:is="item.component"
      class="goal-day-summary__block"
      :key="'x-item-'+item.groupId+'-'+item.id+'-'+idx"
      :value="draggablesList[ idx ]"
      :show-connection="false"
      :draggables-list-virtual-offsets="{}"
      :drag-time-active="false"
      :date-string="viewDate"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import { mapReady } from '@/api/misc'
import clonedeep from "lodash.clonedeep";

import FlowTasklist from "@/components/TodayPage/Elements/Flow/FlowTasklist";
import FlowSequence from "@/components/TodayPage/Elements/Flow/FlowSequence";
import FlowQuickSession from "@/components/TodayPage/Elements/Flow/FlowQuickSession";

export default {
  props: {
    goalId: {
      type: String,
      required: true
    },
    viewDate: {
      type: Object,
      required: true
    },
  },
  computed: {
    // ...mapReady("goals", "commitments", "optimizer_input"),

    ...mapGetters('dayplanner', [
      "dayplan_from_db_at_date",
      "dayplanner_sessions",
    ]),

    dayplan_from_db() {
      return this.dayplan_from_db_at_date( this.viewDate.format('YYMMDD') );
    },

    draggablesList: {
      get() {

        // TODO: THIS IS EXTREMLY SLOW, BC the dayplan is not cached !!!
        // TODO: Move to store -> dayplan_grouped_by_goal

        if (this.dayplan_from_db.length === 0) {
          return [];
        }

        let dayplan = clonedeep(this.dayplan_from_db);
        let draggablesList = [];

        // TODO: AMOUNT, HABIT !!!

        const SUPPORTED_TYPES = [
          'TASKLIST',
          'TIME_BASED_TASKLIST',
          'SEQUENCE',
          'INLINE_TASK',
          'ADHOC_SESSION' ];

        for (let i = 0; i < dayplan.length; i++) {

          let currentBlock = dayplan[i];

          if (  !SUPPORTED_TYPES.includes( currentBlock.type ) ) {
            continue
          }

          /* Filter by goal (skip sessions from other goals) */
          if ( !currentBlock.config
            || !currentBlock.config.goalId
            || currentBlock.config.goalId !== this.goalId ) {
            continue
          }

          /* Attach tasklist for TASKLIST and SEQUENCE */
          if ( currentBlock.type === "TASKLIST"
            || currentBlock.type === "SEQUENCE" ) {

            currentBlock.tasks = this.taskIds_in_session(currentBlock.sessionId);
          }

          currentBlock.original_idx = i; // Side effect: TODO
          draggablesList.push(currentBlock);
        }

        console.log("[DayplanEditor] DAYPLAN", draggablesList);
        return draggablesList; // maybe return dayplan
      }
    },
  },
  methods: {

    /// ---/// ---/// ---/// ---/// ---/// ---/// ---/// --- MIXIN (shared with DayplannerFlowchart)

    taskIds_in_session(sessionId) {
      let tasks = [];
      if ( this.dayplanner_sessions.$readyAll ) {
        let sessions = this.dayplanner_sessions
          .itemsAsArray()
          .filter(session => session.$id === sessionId);
        if (sessions.length === 1) {
          let session = sessions[0];
          tasks = clonedeep(session.tasks) || [];
        }
      }
      return tasks;
    },

    /// ---/// ---/// ---/// ---/// ---/// ---/// ---/// --- MIXIN (shared with DayplannerFlowchart)
  },
  components: {
    FlowTasklist,
    FlowSequence,
    FlowQuickSession,
  }
};
</script>

<style>
.goal-day-summary {
}
.goal-day-summary__block {
  margin-top: 2em;
}

/* hide connectors */
.goal-day-summary__block .flow-block-header::after,
.goal-day-summary__block .flow-block-controls::after {
  display: none;
}

</style>
